<template>
    <div class="success">
        <div class="img">
            <img src="../assets/images/success.png"
                 alt=""
                 class="main">
        </div>
        <div class="title">提交成功</div>
        <div class="tips">您的投诉我们已收到，客服将在24小时内联系您，请耐心等待，谢谢！</div>

    </div>
</template>

<script>
export default {
    name: 'home',
    components: {
    },
    async created () {
    },
    data () {
        return {
            starred: ''
        }
    },
    mounted () {
        // 这里是测试
        console.log('111');
    },
    methods: {
        async test2333 () {
        }
    }
};
</script>
<style scoped  >
.success .img {
    padding-top: 32px;
}
.success .img .main {
    display: block;
    width: 60px;
    height: 60px;
    margin: 0 auto;
}
.success .title {
    padding-top: 12px;
    color: #1b1b1b;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
}
.success .tips {
    padding-top: 8px;
    padding-left: 33px;
    padding-right: 33px;
    color: #7b7b7b;
    font-weight: 14px;
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/pages/comSuccess.vue